// extracted by mini-css-extract-plugin
export default {"wrapper":"mD-z","button":"nD-z","alternate":"oD-z","disabled":"pD-z","paymentWarning":"qD-z","fadeIn":"rD-z"};